









































































































import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {getCalculatorQuestions, get, getPdf, getCalculatorProduct} from '../../services/webclient/webclient';
import {translate} from "../../services/translation/translation";
import './_product-selector-page.less';
import $ from 'jquery';
import progressbar from "@/components/progressbar/progressbar.vue";
import loader from "@/components/loader/loader.vue";
import {goToTop} from "@/services/position/position";

@Component({
    components: {
        progressbar,
        loader,
    }
})

export default class ProductSelectorPage extends Vue {
    @Prop() selectedAnswer;
    @Prop() selectedCalcId;
    @Prop() isShowPrices;
    @Prop() isShowPricesSelector;
    private data: any = {
        models: [],
        System: [],
        viewedQuestions: [],
        sendAnswerData: {},
        r: 0,
        progressbar: {
            'step0': 'passed',
            'step1': 'passed',
            'step2': 'active',
            'step3': ''
        }
    };
    private isLoaded = false;


    activated() {
        if(this.data.System.length != 0){
            goToTop('preview-calculation-page', '');
            this.getProducts();
            window.addEventListener('resize', this.refreshCarusel());
        }
    }

    mounted() {
        goToTop('preview-calculation-page', '');
        let self = this;
        this.getProducts();
        this.refreshCarusel()
    }

    beforeUpdate(){
        this.destroyCarusel();
    }

    updated(){
        this.initCarusel();
    }

    getProducts(){

        let t = {};
        t['data'] = this.getSendDate();
        // t = parseJson(t);
        /*empty products*/
        this.data.System = [];
        getCalculatorProduct(t, this.selectedCalcId).then(data => {
            this.data.System = data.systems;
            this.isLoaded = true;
        }).catch(err => console.warn(err));

    }

    getSendDate(){
        let dataTemp = [];

        $.each(this.selectedAnswer, function (index, question) {
            let obj = {};
            obj['id'] = question.id;
            obj['name'] = question.name;
            if(question.type == 'radio-group'){
                obj['answer'] = {};
                obj['answer']['id'] = question.value_id;
                obj['answer']['value'] = question.value;
            }else if(question.type == 'checkbox-group'){
                obj['answer'] = {};
                obj['answer']['id'] =[];
                $.each(question.value, function (index, value) {
                    obj['answer']['id'].push(value.id);
                })

            }else{
                obj['answer'] = question.value;
            }
            dataTemp.push(obj);
        });


        this.data.sendAnswerData = dataTemp;
        this.onSendAnswerData(dataTemp);

        return dataTemp;
    }

    trans(key) {
        return translate(key);
    }

    refreshCarusel(){
        this.destroyCarusel();
        this.initCarusel();
    }

    initCarusel() {
        try {
            $('.calculations').slick({
                dots: false,
                infinite: true,
                centerMode: false,
                rows: 0,
                slidesToShow: 3,
                slidesToScroll: 3,
                responsive: [{
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                },
                    {
                        breakpoint: 960,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        } catch (ex) {
        }
    }


    destroyCarusel(){
        try {
            $('.calculations').slick('destroy');
        } catch (ex) {
        }
    }

    selectSystem(systemId){
        var self = this;
        var system = null;
        this.onSelectedDetails(systemId);
        $.each(this.data.System, function (index, value) {
            if(value.id == parseInt(systemId)){
                system = value;
            }
        });

        this.onGetCalculatorDefaulSystem(system);
    }
    selectSystemGoToDiscount(systemId){
        var self = this;
        var system = null;
        this.onSelectedDetails(systemId);
        $.each(this.data.System, function (index, value) {
            if(value.id == parseInt(systemId)){
                system = value;
            }
        });
        
        this.onGoToDiscountsFromSelector({system: system,  data: this.data.sendAnswerData});
    }

    @Watch("selectedQuestionValue", {immediate: true, deep: true})
    onSelectedQuestionValue(value) {
    }

    @Emit("selectedAnswer")
    onSelectedAnswer(value) {
    }

    @Emit("selectedDetails")
    onSelectedDetails(systemId) {
    }
    @Emit("goToDiscountsFromSelector")
    onGoToDiscountsFromSelector(data/*system,data*/) {
    }
    @Emit("getCalculatorDefaulSystem")
    onGetCalculatorDefaulSystem(systems) {
    }

    @Emit("sendAnswerData")
    onSendAnswerData(data) {
    }

    @Emit("backToQuestions")
    backToQuestions(systems) {
    }
}

